module.exports = __webpack_public_path__ + "static/media/fixura_logo_color.cae62737.svg";